<div class="user-menu-container">
    <button mat-button  class="menu-button" (click)="onMenuClick()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-menu icon phr-iconset"></mat-icon>
        <img [src]="loggedInUser.ubicacionLogo">
    </button>
</div>